import { useEffect, useState } from 'react';

export default function useDebounce(value: any, initialValue: any, delay = 500) {
    const [state, setState] = useState(initialValue);

    useEffect(() => {
        // Using setTimeout() here only for debouncing purposes to avoid unnecessary API calls
        const timer = setTimeout(() => setState(value), delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return state;
}
